import { List as ImmutableList } from 'immutable';
import { isNonReportWidgetReport } from 'dashboard-lib/public/report/report-config-types';
//@ts-expect-error Untyped dependency
import { isDashboardOnlyContentWidget } from 'reporting-action-components/lib/report-logic';
import { getDataTypeFamiliesFromReports } from '../categorizationUtils/dataTypeFamilyDerivationUtils';
import { getDimensionTypesFromReports } from '../categorizationUtils/dimensionCategorizationUtils';
import { getHubsFromReports } from '../categorizationUtils/hubCategorizationUtils';
export const getReportsFromDashboard = dashboard => {
  const widgets = dashboard.get('widgets');
  return widgets.reduce((acc, widget) => {
    if (isNonReportWidgetReport(widget.toJS())) {
      return acc;
    }
    const report = widget.get('report');
    if (isDashboardOnlyContentWidget(report)) {
      return acc;
    }
    return acc.push(report);
  }, ImmutableList());
};
export const getRelevancyDataFromDashboard = dashboard => {
  const reports = getReportsFromDashboard(dashboard);
  const dashboardDataTypeFamilies = getDataTypeFamiliesFromReports(reports);
  return {
    dataTypes: dashboardDataTypeFamilies,
    dimensionTypes: getDimensionTypesFromReports(reports),
    hubs: getHubsFromReports(reports)
  };
};